export enum AddDeviceToGatewayStatus {
	InProgress = 'IN_PROGRESS',
	Success = 'SUCCESS',
	GenericFailure = 'GENERIC_FAILURE',
	DeviceNotFound = 'DEVICE_NOT_FOUND',
	UnsupportedFirmwareVersion = 'UNSUPPORTED_FIRMWARE_VERSION',
	GatewayNotFound = 'GATEWAY_NOT_FOUND',
	GatewayNotEnabled = 'GATEWAY_NOT_ENABLED',
	GatewayCannotProxy = 'GATEWAY_CANNOT_PROXY',
	MaxDeviceLimitReached = 'MAX_DEVICE_LIMIT_REACHED'
}

export interface AddDevicesToGatewayResult {
	devices: {
		hardwareId: string;
		status: AddDeviceToGatewayStatus;
	}[];
}
